const config = {
  development: {
    ROOT_URL: 'https://dev.nextship.net',
  },
  stage: {
    ROOT_URL: 'https://stage.nextship.net',
  },
  production: {
    ROOT_URL: 'https://nextship.net',
  },
}

const getEnvironment = () => {
  const hostname = window.location.hostname

  if (hostname.includes('dev') || hostname.includes('localhost')) {
    return 'development'
  } else if (hostname.includes('stage')) {
    return 'stage'
  } else {
    return 'production'
  }
}

const currentEnv = getEnvironment()

export default config[currentEnv]
